import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    GET_ALL_LEADS,GET_LEAD_DETAILS,GET_LEAD_FILTERS,UPDATE_LEAD_STATUS,UPDATE_LEAD_ACCOUNT,CREATE_NEW_LEAD,FETCH_CUSTOMER_DETAILS
} from "./type";

export const getAllLeadsListing = (status=1,filterInputList,searchValue,page=1,paginate=true) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        status: status,
        search: searchValue,
        page:page,
        paginate:paginate,
        ...filterInputList?.[0], 
    }).toString();
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getAllLeads}?${queryParams}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_ALL_LEADS,
            payload: data.response.data.lead_data,
        });
        return data.response.data;
    }
};

export const getLeadDetails = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getLeadDetails}?id=${id}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_LEAD_DETAILS,
            payload: data.response.data,
        });
        return data.response.data;
    }
};

export const getLeadFilters = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getLeadFilters}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_LEAD_FILTERS,
            payload: data.response,
        });
        return data.response.data;
    }
};
export const updateLeadStatus = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.updateLeadStatus}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: UPDATE_LEAD_STATUS,
            payload: data.response.data,
        });
        return data;
    }
};

export const createNewLead = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.createNewLead}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: CREATE_NEW_LEAD,
            payload: data.response.data,
        });
        return true;
    }
};

export const updateLeadAccount = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.updateLeadAccount}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: UPDATE_LEAD_ACCOUNT,
            payload: data.response.data,
        });
        return data.response;
    }
};

export const fetchCustomerDetails = (panNumber) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fetchPanDetails}?pan_number=${panNumber}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: FETCH_CUSTOMER_DETAILS,
            payload: data.response.data,
        });
        console.log("data", data)
        return data.response.data;
    }
};
